import React from 'react';
import '../styles/PressReleasesAdmin.css';

export default function PressReleasesAdmin() {
  return (
    <div>PressReleasesAdmin</div>
  )
}
